import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import { Field } from 'redux-form';

import FilterField from 'components/fields/FilterField';

const styles = () => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%', // to contain super-long filters, for example in reports
  },
  rootNoWrap: {
    flexWrap: 'nowrap',
  },
  filterField: {
    margin: '5px 4px 3px 4px',
    maxWidth: 'calc(100% - 10px)',
  },
  filterFieldXs: {
    margin: '2px 4px 1px 4px',
  },
});

class FiltersFieldArray extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offsetFields: [],
      draggableData: {},
      dragged: false,
      timestamp: Date.parse(new Date()),
    };

    this.onFieldDragStart = this.onFieldDragStart.bind(this);
    this.onFieldDrag = this.onFieldDrag.bind(this);
    this.onFieldDragStop = this.onFieldDragStop.bind(this);
    this.onDraggableDataChange = this.onDraggableDataChange.bind(this);
  }

  onDraggableDataChange(data) {
    this.setState({
      draggableData: {
        ...this.state.draggableData,
        ...data,
      },
    });
  }

  onFieldDragStart() {
    this.setState({ dragged: true });
  }

  onFieldDrag(data) {
    const { fields } = this.props;
    const { draggableData } = this.state;
    const moveDirectionX = ((Math.abs(data.defaultX - data.x) > 5 && data.x > data.defaultX)
      || ((Math.abs(data.defaultX - data.x) <= 5
        && Math.abs(data.defaultY - data.y) > 5 && data.y > data.defaultY)))
      ? 'right' : 'left';
    const offsetFields = fields.reduce((accumulator, field, index) => {
      if (index === data.index) {
        return accumulator;
      }
      if (moveDirectionX === 'right') {
        if ((index > data.index
          || (data.defaultY > -draggableData[index].bounds.top && data.index !== index + 1))
          && draggableData[index] !== undefined
          && ((draggableData[index].width / 2) - draggableData[index].bounds.left)
          < (data.x + data.width)
          && (data.y < (draggableData[index].height / 2) - draggableData[index].bounds.top)
          && (data.y >= -draggableData[index].bounds.top - (draggableData[index].height / 2))) {
          return [
            ...accumulator,
            {
              fieldIndex: index,
              offsetX: -10,
            },
          ];
        }
        return accumulator;
      }
      if (moveDirectionX === 'left') {
        if ((index < data.index
          || (data.defaultY < -draggableData[index].bounds.top && data.index !== index - 1))
          && draggableData[index] !== undefined
          && ((draggableData[index].width / 2) - draggableData[index].bounds.left) > data.x
          && (data.y < (draggableData[index].height / 2) - draggableData[index].bounds.top)
          && (data.y >= -draggableData[index].bounds.top - (draggableData[index].height / 2))) {
          return [
            ...accumulator,
            {
              fieldIndex: index,
              offsetX: 10,
            },
          ];
        }
        return accumulator;
      }
      return accumulator;
    }, []);
    this.setState({ offsetFields });
  }

  onFieldDragStop(data) {
    const { fields } = this.props;
    const { offsetFields } = this.state;
    if (offsetFields.length > 0) {
      const moveDirectionX = ((Math.abs(data.defaultX - data.x) > 5 && data.x > data.defaultX)
        || ((Math.abs(data.defaultX - data.x) <= 5
          && Math.abs(data.defaultY - data.y) > 5 && data.y > data.defaultY)))
        ? 'right' : 'left';
      let moveIndex;
      this.setState({
        dragged: false,
        offsetFields: [],
      });
      if (moveDirectionX === 'left') {
        moveIndex = offsetFields[0].fieldIndex;
      }
      if (moveDirectionX === 'right') {
        moveIndex = offsetFields[offsetFields.length - 1].fieldIndex;
      }
      if (moveIndex !== undefined) {
        const nextFocusedFieldEl = this.rootRef.querySelector(`[data-index='${moveIndex}']`);
        if (nextFocusedFieldEl) {
          nextFocusedFieldEl.focus();
        }
        fields.move(data.index, moveIndex);
        this.setState({ timestamp: Date.parse(new Date()) });
      }
    }
  }

  render() {
    const {
      fields,
      prefix,
      colored,
      size,
      firstHighlighted,
      draggable,
      endAdornment,
      classes,
      id,
      onFieldDelete,
      disabled,
      noWrap,
    } = this.props;
    const { dragged, offsetFields, timestamp } = this.state;
    return (
      <div
        className={classNames(classes.root, {
          [classes.rootNoWrap]: noWrap,
        })}
        ref={(rootRef) => {
          this.rootRef = rootRef;
        }}
        id={id}
      >
        {fields.map((field, index) => {
          const offsetFieldIndex = offsetFields
            .findIndex(item => (item.fieldIndex === index));
          return (
            <Field
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              index={index}
              className={classNames(classes.filterField, {
                [classes.filterFieldXs]: size === 'xs',
              })}
              name={field}
              component={FilterField}
              {...prefix ? { prefix } : {}}
              colored={colored}
              highlighted={firstHighlighted && index === 0}
              size={size}
              onDelete={() => {
                if (!disabled) {
                  onFieldDelete(index);
                  fields.remove(index);
                }
              }}
              {...(draggable && fields.length > 1)
                ? {
                  draggable: true,
                  boundsSelector: `[id="${id}"]`,
                  onStartDrag: this.onFieldDragStart,
                  onDrag: this.onFieldDrag,
                  onStopDrag: this.onFieldDragStop,
                  onDraggableDataChange: this.onDraggableDataChange,
                  withTransition: dragged,
                  timestamp,
                  onKeyDown: (event) => {
                    if (event.key === 'ArrowLeft' && index !== 0) {
                      fields.move(index, index - 1);
                      const nextFocusedFieldEl = this.rootRef.querySelector(`[data-index='${index - 1}']`);
                      if (nextFocusedFieldEl) {
                        nextFocusedFieldEl.focus();
                      }
                    }
                    if (event.key === 'ArrowRight' && index !== fields.length - 1) {
                      fields.move(index, index + 1);
                      const nextFocusedFieldEl = this.rootRef.querySelector(`[data-index='${index + 1}']`);
                      if (nextFocusedFieldEl) {
                        nextFocusedFieldEl.focus();
                      }
                    }
                  },
                  ...offsetFieldIndex !== -1
                    ? {
                      offsetY: offsetFields[offsetFieldIndex].offsetY,
                      offsetX: offsetFields[offsetFieldIndex].offsetX,
                    } : {},
                }
                : {
                  draggable: false,
                }}
            />
          );
        })}
        {endAdornment && endAdornment}
      </div>
    );
  }
}

FiltersFieldArray.propTypes = {
  id: PropTypes.string.isRequired,
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
    remove: PropTypes.func.isRequired,
  }).isRequired,
  prefix: PropTypes.string,
  colored: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  firstHighlighted: PropTypes.bool,
  draggable: PropTypes.bool,
  endAdornment: PropTypes.node,
  onFieldDelete: PropTypes.func,
  disabled: PropTypes.bool,
  noWrap: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    filterField: PropTypes.string.isRequired,
  }).isRequired,
};

FiltersFieldArray.defaultProps = {
  prefix: null,
  colored: false,
  size: 'md',
  firstHighlighted: false,
  draggable: false,
  endAdornment: null,
  onFieldDelete: () => {},
  disabled: false,
  noWrap: false,
};

export default withStyles(styles)(FiltersFieldArray);



// WEBPACK FOOTER //
// ./src/components/fields/FiltersFieldArray.js